import { useState } from 'react';
import { useSelector } from 'react-redux';
import { api } from '../redux/axios/api';
import { servicios } from '../redux/helpers';
import { transactionResponse } from '../redux/models/app.model';
import {
  maintenanceRequest,
  maintenanceTestRequest,
  maintenancePhotoRequest,
  maintenanceSupplieRequest,
} from '../redux/models/mantenimiento.model';

const useMantenimiento = () => {
  const { currentUser } = useSelector((state) => state.app);
  const [processingMaintenance, setProcessingMaintenance] = useState(false);
  const [maintenance, setMaintenance] = useState([]);

  const getPreviusMaintenance = (so) => {
    setProcessingMaintenance(true);
    api
      .get(`${servicios.MANTENIMIENTO}/previos`, {
        params: { so, em: currentUser.ie },
      })
      .then((response) => setMaintenance(response))
      .catch((error) => console.log(error.data))
      .finally(() => setProcessingMaintenance(false));
  };

  /**
   * Get Previus data equipment.
   * @param {string} eq id equipment
   * @param {string} so id request
   * @returns result
   */
  const getEquipmentPrevius = async (eq, so) => {
    let result = transactionResponse;
    const params = {
      eq,
      so,
      em: currentUser.ie,
    };
    try {
      let response = await api.get(`${servicios.MANTENIMIENTO}/identificador`, {
        params,
      });
      result.success = true;
      result.status = 'success';
      result.result = response;
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  /**
   * Get photos of maintenance equipment.
   * @param {string} so id request
   * @param {string} eq id equipment
   * @returns photos
   */
  const getPhotos = async (so, eq) => {
    let result = transactionResponse;
    try {
      let response = await api.get(`${servicios.SOLICITUD}/imagen`, {
        params: { so, eq, em: currentUser.ie },
      });
      result.success = true;
      result.status = 'success';
      result.result = response;
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  /**
   * Grabar datos de las imageens de mantenimiento.
   * @param {maintenancePhotoRequest} data datos de la imagen
   */
  const patchPhoto = async (data) => {
    let result = transactionResponse;

    try {
      let form_data = new FormData();
      form_data.append('file', data.im);
      form_data.append('nt', data.nt);
      form_data.append('ie', currentUser.ie);
      form_data.append('ua', currentUser.us);
      form_data.append('so', data.so);
      form_data.append('eq', data.eq);
      form_data.append('ia', data.ia);

      await api.patch(`${servicios.SOLICITUD}/adjuntar`, form_data, {
        headers: { 'content-type': 'multipart/form-data; charset=utf-8' },
      });
      result.success = true;
      result.status = 'success';
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  /**
   * Grabar datos de resultados de mantenimiento.
   * @param {maintenanceTestRequest} data datos de requerimiento
   */
  const postMaintenanceResult = async (data) => {
    let result = transactionResponse;
    try {
      await api.post(`${servicios.MANTENIMIENTO}/testeos`, {
        ...data,
        ie: currentUser.ie,
        ua: currentUser.us,
      });
      result.success = true;
      result.status = 'success';
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  /**
   * Guardar datos de insumos de mantenimiento.
   * @param {maintenanceSupplieRequest} data datos de insumos
   */
  const postMaintenanceSupplies = async (data) => {
    let result = transactionResponse;
    try {
      await api.post(`${servicios.MANTENIMIENTO}/insumos`, {
        ...data,
        ie: currentUser.ie,
        ua: currentUser.us,
      });
      result.success = true;
      result.status = 'success';
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  /**
   * Guardar datos de mantenimiento de equipo.
   * @param {maintenanceRequest} data datos de requerimiento
   * @returns
   */
  const postMaintenance = async (data) => {
    let result = transactionResponse;
    try {
      const response = await api.post(`${servicios.MANTENIMIENTO}`, {
        ...data,
        ie: currentUser.ie,
        ua: currentUser.us,
      });
      result.success = true;
      result.status = 'success';
      result.result = response;
      return result;
    } catch (error) {
      result.success = false;
      result.status = 'fail';
      if (error.data) {
        if (error.data.errors) {
          result.fieldsErrors = error.data.errors;
        } else {
          result.messageError = error.data.detail;
        }
      } else {
        result.messageError = 'Error en el servicio';
      }
      return result;
    }
  };

  return {
    processingMaintenance,
    maintenance,
    getPreviusMaintenance,
    getEquipmentPrevius,
    getPhotos,
    patchPhoto,
    postMaintenanceResult,
    postMaintenanceSupplies,
    postMaintenance,
  };
};

export default useMantenimiento;
